<template>
  <base-modal
    class="media_modal"
    @close="closeAddPageModal"
  >
    <template #heading>
      Select page
    </template>

    <custom-multiselect
      v-model="selectedPages"
      label="Select the page(s) to add from the list below"
      :options="pagesForDropdown"
      placeholder="Select pages from the list"
      mode="tags"
      :disabled="pageUrl !== ''"
    />

    <custom-input
      v-model="pageUrl"
      label="Or enter your own URL"
      placeholder="http://website.com/"
      :disabled="selectedPages.length > 0"
      :validation-errors="errors.pageUrl ?? null"
    />

    <div class="new_page_checkbox">
      <input
        id="newPageCheck"
        v-model="newPage"
        type="checkbox"
        :disabled="selectedPages.length > 0"
      >
      <label for="newPageCheck">
        Check this box if you haven't built this page yet
        <i
          class="fal fa-question-circle tooltipster"
          :title="tooltipText"
        />
      </label>
    </div>

    <template #footer>
      <div class="buttons">
        <secondary-button
          size="md"
          @click="closeAddPageModal"
        >
          Cancel
        </secondary-button>
        <primary-button
          size="md"
          :class="(processing || noInput) ? 'disabled' : ''"
          @click="addPages"
        >
          <i
            v-if="processing"
            class="fas fa-spinner fa-spin"
          />
          {{ selectedPages.length > 1 ? 'Add Pages' : 'Add Page' }}
        </primary-button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from "../../global/modals/BaseModal";
import CustomInput from "../../../../views/reports/components/global/forms/CustomInput";
import CustomMultiselect from "../../../../views/reports/components/global/forms/CustomMultiselect";
import {mapActions, mapGetters} from "vuex";
import _ from 'lodash';
import SecondaryButton from "../../global/buttons/SecondaryButton";
import PrimaryButton from "../../global/buttons/PrimaryButton";

export default {
  components: {
    PrimaryButton,
    SecondaryButton,
    CustomMultiselect,
    BaseModal,
    CustomInput,
  },
  emits: ['close'],
  data() {
    return {
      selectedPage: null,
      selectedPages: [],
      pageUrl: '',
      newPage: false,
      tooltipText: 'Sometimes you will not have a page on the website currently '+
          'but you want to plan for when it is being added. If this is the case tick this '+
          'box and we will create an action to create a new page.',
      errors: {},
    }
  },
  computed: {
    ...mapGetters('strategy', [
      'processing',
      'pages',
    ]),
    pagesForDropdown() {
      return _.map(this.pages, (page, index) => ({value: index,  label: page.page_url}));
    },
    noInput() {
      return this.selectedPages.length === 0 && this.pageUrl === '';
    }
  },
  watch: {
    selectedPages(newValue) {
      if (newValue.length > 0) {
        this.newPage = false;
      }
    }
  },
  methods: {
    ...mapActions('strategy', [
      'fetchStrategy',
      'addPagesToSitemap',
      'createPageAndAddToSitemap',
      'closeAddPageModal',
    ]),
    addPages() {
      if (this.selectedPages.length > 0) {
        let pagesToAdd = [];
        this.selectedPages.forEach(index => {
          pagesToAdd.push(this.pages[index]);
        })
        this.addPagesToSitemap(pagesToAdd).then(() => {
          this.closeAddPageModal();
        });
        return;
      }

      const {pageUrl, newPage} = this;
      this.createPageAndAddToSitemap({pageUrl, newPage}).then(() => {
        this.closeAddPageModal();
      }).catch((errors) => {
        this.errors = errors;
      })
    }
  },
}
</script>

<style lang="scss" scoped>
:deep(.modal_window) {
  max-width: 1000px;
}

:deep(.custom-multiselect) {
  --ms-font-size: 0.875rem;
}

.new_page_checkbox {
  padding: 7px 0;
  min-height: auto;

  input[type=checkbox] {
    margin: 0;
    display: none;
    width: 22px;

    &+label[disabled] {
      cursor: none;
    }

    &+label {
      font-size: 0.8rem;
      line-height: 1.3;
      letter-spacing: -0.1px;
      color: #909096;
      cursor: pointer;

      &:before {
        content: "";
        width: 22px;
        height: 22px;
        display: inline-block;
        border: 2px solid #e6ecf5;
        border-radius: 3px;
        margin-right: 10px;
        font-size: 15px;
        font-weight: 400;
        line-height: 19px;
        vertical-align: bottom;
        text-align: center;
        background-color: #ffffff;

      }

      i {
        color: #00c6dd;
      }
    }


    &:checked+label:before {
      content: '\2713';
      color: var(--primary-color);
    }
  }
}

.buttons {
  display: flex;
  justify-content: flex-end;
  gap: 5px;
}
</style>
